
import { PureConnect, React } from '../../react';
import HOVER_ITEM from './actions/HOVER';
import { IParticipant, IUsergroup } from '../../types';
import cx from './usergroupblock.less';
import { participantsResource } from '../../participant/resource';
import { Btn } from '../../react-toolbox-redesign/button';
import { captionAdmin, captionClerk, captionPracticioner, tileTextAdmin, tileTextClerk, tileTextPracticioner, typeRoleAdmin, typeRoleClerk } from '../../admin/adminText';
import { usergroupEditor } from '../../usergroup/resource';

interface IUserGroupProps {
    keyprefix: string;
    item: IUsergroup;
    itemno?: number;    
    onEdit: any;
    onDelete: any;
    onInspect: any;
}

export const UserGroupBlock = PureConnect<any|IUserGroupProps>(`UserGroupBlock`)(
    (state) => ({
        hoveredId : state.admin.hoveredId,
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
    }),
    (dispatch) => ({ 
        hoverItem: (hoveredId: string) => dispatch(HOVER_ITEM({ hoveredId })),
        hoverItemOut: () => dispatch(HOVER_ITEM({hoveredId: '' })),
    }),
    ({ item, keyprefix, allparticipants, onEdit, onDelete, onInspect, hoveredId, hoverItemOut, hoverItem, extraClassNames }) => {
    
    let usergroup: IUsergroup = item;
    return (

        <div className={cx('container', extraClassNames)} onMouseEnter={() =>hoverItem(keyprefix + item.id)} onMouseLeave={() => hoverItemOut()}>
            <div className={cx('content-container')}>
                <div className={cx('header')}>                    
                    <div className={cx('contentheader')}>
                        <div className={cx('icon-left-container')}>
                            <span className={cx('icon-container', 'icon-shared_multiple')}></span>
                        </div>
                        <div className={cx('icon-middle-first-container')}>
                            <div className={cx('text-container_author')}>
                                <span id={`id-ref-${usergroup.id}`} className={cx('autho-container')}>Groep</span>
                                <p id={`id-ref-${usergroup.id}`} className={cx('autho-name')}>{usergroup.name}</p>
                            </div>
                            <div className={cx('container-shared-with')}>
                                <span className={cx('shared-with-label')}>Leden</span>
                                <div className={cx('icons-container')}>
                                    {usergroup&&usergroup.userIDs&&usergroup.userIDs.length?<span title={mapParticipantsNames(usergroup.userIDs, allparticipants)} className={cx('icon-shared_multiple')}></span>: null}
                                    {usergroup&&usergroup.userIDs&&usergroup.userIDs.length?<span className={cx('shared-count')}>{participantsCount(usergroup.userIDs, allparticipants)}</span>: null}
                                </div>
                            </div>     
                            <div className={cx('text-container_author')}>
                                    <span className={cx('autho-container')}>Eigenaar</span>
                                    <span className={cx('autho-name')}>{mapParticipantsNames([usergroup.userId], allparticipants)}</span>
                            </div>                                                      
                        </div>
                    </div>                 
                </div>
            </div>
            { hoveredId === keyprefix + item.id ?
                <div className={cx('right-side-area')}>
                    <span className={cx('icon-edit')} onClick={() => onEdit(usergroup)}></span>
                    <span className={cx('icon-show')} onClick={() => onInspect(usergroup)}></span>
                    <span className={cx('icon-delete')} onClick={() => onDelete(usergroup)}> </span>
                </div>
                :null
            } 
        </div>
    );
  });

export const FactionBlock = PureConnect<any|IUserGroupProps>(`FactionBlock`)(
(state) => ({
    hoveredId : state.admin.hoveredId,
    allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
}),
(dispatch) => ({ 
    hoverItem: (hoveredId: string) => dispatch(HOVER_ITEM({ hoveredId })),
    hoverItemOut: () => dispatch(HOVER_ITEM({hoveredId: '' })),
}),
({ item, keyprefix, onEdit, onDelete, onInspect, hoveredId, hoverItemOut, hoverItem, extraClassNames }) => {

let usergroup: IUsergroup = item;
return (

    <div className={cx('container-faction', extraClassNames)} onMouseEnter={() =>hoverItem(keyprefix + item.id)} onMouseLeave={() => hoverItemOut()}>
        <div className={cx('content-container')}>
            <div className={cx('header')}>                    
                <div className={cx('contentheader')}>
                    <div className={cx('left-container-faction')}>
                        <div className={cx('text-container_author')}>
                            <p id={`id-ref-${usergroup.id}`} className={cx('autho-name')}>{usergroup.name}</p>
                        </div> 
                    </div>
                    <div className={cx('middle-container-faction')}>
                        <Btn 
                            type="button"
                            className={'btn'} 
                            extraClassNames={'secondary-btn'}
                            aria-label={'Wijzig fractie'}
                            aria-haspopup={false}                        
                            tabIndex={0}                                                                                                                        
                            onClick={() => onEdit(usergroup)}                                                                
                            disabled={false}>
                            <span>WIJZIGEN</span>
                        </Btn>                                                       
                    </div>
                </div>                 
            </div>
        </div>
        { hoveredId === keyprefix + item.id?
            <div className={cx('right-side-area')}>
                <span className={cx('icon-show')} onClick={() => onInspect(usergroup)}></span>
                <span className={cx('icon-delete')} onClick={() => onDelete(usergroup)}> </span>
            </div>:
            null
        } 
    </div>
);
});

export const RoleBlock = PureConnect<any|IUserGroupProps>(`RoleBlock`)(
    (state) => ({
        hoveredId : state.admin.hoveredId,
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
    }),
    (dispatch) => ({ 
        hoverItem: (hoveredId: string) => dispatch(HOVER_ITEM({ hoveredId })),
        hoverItemOut: () => dispatch(HOVER_ITEM({hoveredId: '' })),
    }),
    ({ item, onEdit, extraClassNames }) => {
    
    let usergroup: IUsergroup = item;
    return (
    
        <div className={cx('container-role', extraClassNames)}>
            <div className={cx('content-container')}>
                <div className={cx('header')}>                    
                    <div className={cx('contentheader')}>
                        <div className={cx('left-container-role')}> 
                            <div className={cx('text-container_author')}>
                                <p id={`id-ref-${usergroup.id}`} className={cx('autho-name')}>
                                    { usergroup.type === typeRoleAdmin ? captionAdmin :
                                        usergroup.type === typeRoleClerk ? captionClerk :
                                        captionPracticioner }                                    
                                </p>  
                            </div> 
                        </div>
                        <div className={cx('right-container')}>
                            <Btn 
                                type="button"
                                className={'btn'} 
                                extraClassNames={'secondary-btn'}
                                aria-label={'Wijzig fractie'}
                                aria-haspopup={false}                        
                                tabIndex={0}                                                                                                                        
                                onClick={() => onEdit(usergroup)}                                                                
                                disabled={false}>
                                <span>WIJZIGEN</span>
                            </Btn>                                                       
                        </div>
                        <div className={cx('left-sub-container')}>
                            <p id={`id-ref-role-descr-${usergroup.id}`} className={cx('role-descr')}>
                                    { usergroup.type === typeRoleAdmin ? tileTextAdmin :
                                        usergroup.type === typeRoleClerk ? tileTextClerk :
                                        tileTextPracticioner }
                            </p> 
                        </div>                        
                    </div>                 
                </div>
            </div>
        </div>
    );
    });

export const RoleBlockNew = PureConnect<any|IUserGroupProps>(`RoleBlockNew`)(
    (state) => ({
    }),
    (dispatch) => ({ 
        createRole: (typeRole: number) => 
            dispatch(usergroupEditor.actions.CREATE({ item: { name: typeRole === typeRoleAdmin ? captionAdmin :
                                                                    typeRole === typeRoleClerk ? captionClerk :
                                                                    captionPracticioner, userIDs:[], type: typeRole } })), 
    }),
    ({ createRole, extraClassNames, typeRole }) => {

    return (
    
        <div className={cx('container-role', extraClassNames)}>
            <div className={cx('content-container')}>
                <div className={cx('header')}>                    
                    <div className={cx('contentheader')}>
                        <div className={cx('left-container-role')}> 
                            <div className={cx('text-container_author')}>
                                <p id={`id-ref-${ typeRole === typeRoleAdmin ? captionAdmin :
                                        typeRole === typeRoleClerk ? captionClerk :
                                        captionPracticioner }`} className={cx('autho-name')}>
                                    { typeRole === typeRoleAdmin ? captionAdmin :
                                        typeRole === typeRoleClerk ? captionClerk :
                                        captionPracticioner }                                    
                                </p>  
                            </div> 
                        </div>
                        <div className={cx('right-container')}>
                            <Btn 
                                type="button"
                                className={'btn'} 
                                extraClassNames={'secondary-btn'}
                                aria-label={'Wijzig fractie'}
                                aria-haspopup={false}                        
                                tabIndex={0}                                                                                                                        
                                onClick={() => createRole(typeRole)}                                                                
                                disabled={false}>
                                <span>WIJZIGEN</span>
                            </Btn>                                                       
                        </div>
                        <div className={cx('left-sub-container')}>
                            <p id={`id-ref-role-descr-${typeRole === typeRoleAdmin ? tileTextAdmin :
                                         typeRole === typeRoleClerk ? tileTextClerk :
                                        tileTextPracticioner }`}>
                                    { typeRole === typeRoleAdmin ? tileTextAdmin :
                                        typeRole === typeRoleClerk ? tileTextClerk :
                                        tileTextPracticioner }
                            </p> 
                        </div>                        
                    </div>                 
                </div>
            </div>
        </div>
    );
    });

function mapParticipantsNames(participantIds: string[], allparticipants: IParticipant[]) {
    let participantstring='';

    const participants = allparticipants.qWhere((item) => participantIds ? participantIds.qIncludes(item.id):false);
    participantstring = participants && participants.qAny()? 
        `${participants.map((x) => {
            return x.name;
        }).join(', ')}`:        
        '';
    return participantstring;
}

function participantsCount(participantIds: string[], allparticipants: IParticipant[]) {
    const participants = allparticipants.qWhere((item) => participantIds ? participantIds.qIncludes(item.id):false);
    return participants&&participants.length;
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/admin/usergroupblock.tsx